import React, { FC, useEffect, useMemo, useState } from 'react';
import { StepProps } from "../../types/types";
import { useTranslation } from "react-i18next";
import DeliveryDatePicker from "../business/DeliveryDatePicker";
import ReturnDatePicker from "../business/ReturnDatePicker";
import HomeAddressField from "../business/HomeAddressField";
import TransforceComment from "../business/TransforceComment";
import {BuildingDetails} from "../business/BuildingDetails";
import { setHomeAddress as setAddressRedux } from '../../stateReducers/deliverySlice';
import { TFDeliveryService } from '../../api/TFDeliveryService';
import { useAppDispatch, useAppSelector } from '../../hooks';
import ValidatedAddressField from '../business/ValidatedAddressField';
import { isBelgianAddress } from '../utils/stateHelper';

const DeliveryAtHomeReturnTransforce: FC<StepProps> = ({setStepValidity}) => {
    const {t} = useTranslation();
    const [readonly, setReadonly] = useState(false);
    const deliveryOptions = useAppSelector((state) => {
        return state.delivery;
    });
    const d = useAppDispatch();
    const homeAddress = useAppSelector((state) => state.delivery.homeAddress);
    const country = useAppSelector((state) => state.invoiceDetails.country);
    const [addressValid, setAddressValid] = useState<boolean>(false);
    function setHomeAddress(address: string | undefined) {
        d(setAddressRedux({homeAddress: address, country: country}));
    }
    const tfDeliveryService = useMemo(() => {
        console.error("New delivery service created");
        return new TFDeliveryService();
    }, [deliveryOptions.playStart, deliveryOptions.playEnd]);

    const [deliveryDatePickerValid, setDeliveryDatePickerValid] = useState<boolean>(false);
    
    useEffect(() => {
        let isValid = !!deliveryOptions.homeAddress && !!deliveryOptions.returnDate && !!deliveryOptions.deliveryDate
            && !!deliveryOptions.homeAddressValid && addressValid;
        // The address must be in Belgium for this kind of delivery
        isValid = isValid && (deliveryOptions.homeAddress !== undefined && isBelgianAddress(deliveryOptions.homeAddress));
        isValid = isValid && (deliveryOptions.building ==='house' || !!deliveryOptions.buildingDetails);
        isValid = isValid && deliveryDatePickerValid;
        setStepValidity(isValid);
    });

    return (
        <div>
            <div className="form-group mb-6 flex flex-col">
                <ValidatedAddressField
                    label={t('delivery.homeAddressLabel')}
                    address={homeAddress}
                    setAddress={setHomeAddress}
                    addressValid={addressValid}
                    setAddressValid={setAddressValid}
                    mustBeBelgianAddress={true}
                    mustHaveStreetNumber={true}
                    wallonianAddressesAllowed={false}
                />
                {deliveryOptions.playStart && <div className="mb-3 xl:w-full">
                    <label className="form-label inline-block mb-2 text-gray-700">{t('delivery.deliveryTime')}</label>
                    <DeliveryDatePicker readonly={readonly}
                                        deliveryService={tfDeliveryService}
                                        setDeliveryDatePickerValid={setDeliveryDatePickerValid}
                    />
                </div>
                }
                {deliveryOptions.playEnd && <div className="mb-3 xl:w-full">
                    <label className="form-label inline-block mb-2 text-gray-700">{t('delivery.pickupTime')}</label>
                    <ReturnDatePicker deliveryService={tfDeliveryService}/>
                </div>
                }
                <BuildingDetails />
                <TransforceComment />
            </div>
        </div>
    );
};

export default DeliveryAtHomeReturnTransforce;
